import KeyboardFocusable from '../KeyboardFocusable';

import Controls from './Controls';


export default class PopupAlone extends Controls {
    namespace = 'popupAlone';
    constructor() {
        super();
    }

    init() {
        const prevBtn = document.getElementById('modal-dialog-cancel-button');
        const nextBtn = document.getElementById('modal-dialog-ok-button');

        if (prevBtn) {
            this._items.push(new KeyboardFocusable(prevBtn));
        }
        if (nextBtn) {
            this._items.push(new KeyboardFocusable(nextBtn));
        }
    }

    focus() {
        if (this._items[this._currentIndex]) {
            this._items[this._currentIndex].focus();
        }
    }

    destroy() {
        this._items = [];
        this._currentIndex = 0;
    }

    isPossibleUp() {
        return false;
    }

    isPossibleDown() {
        return false;
    }

    next() {
        this.down();
    }

    prev() {
        this.up();
    }
}
